<template>
  <div>
    <!-- use for prod only uncomment simultaneously according to the builds need -->
    <!-- <HeaderComponent/> -->
    <FooterComponent/>
    <!-- use for prod only uncomment simultaneously according to the builds need-->

    <!-- Using Route only for development purpose (keep commented for prod/stage)-->
    <!-- <router-view /> -->
    <!-- Using Route keep the components commented -->
  </div>
</template>

<script>
// import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';
export default {
  name: "App",
  components: {
    // HeaderComponent,
    FooterComponent
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700");
@import 'assets/css/main.scss';
</style>
